import {
  uploadBytesResumable,
  ref,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { storage } from "../../firebase/firebase";

export const FileServices = {
  getReference: (type, filename) => {
    let storageRef = {};
    switch (type) {
      case "image/*":
        storageRef = ref(storage, `/images/${filename}`);
        break;
      case "application/pdf":
        storageRef = ref(storage, `/pdf/${filename}`);
    }

    return storageRef;
  },

  uploadFile: async (file, storageRef) => {
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        console.log(error);
      }
    );

    await uploadTask;
    let downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
    return downloadURL;
  },

  deleteFile: (fileRef) => {
    deleteObject(fileRef)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  },
};
